import apiConfig from '../../../config/api'
import { apiRequestorHelper } from '../../../helpers'

export default {
	save: (client) => {
		const isFormData = typeof FormData !== 'undefined' && client instanceof FormData
		return apiRequestorHelper({
			url: apiConfig.url + '/user/createUser',
			method: 'post',
			body: client,
			headers: isFormData
				? {
					'Content-Type': 'multipart/form-data'
				}
				: {}
		})
	},
	upload: (formData) => {
		return apiRequestorHelper({
			url: apiConfig.url + '/uploadClientes',
			method: 'post',
			body: formData,
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		})
	}
}
